export default class JobQueue {
    jobs = [];
    isProcessing = false;
    delay;
    timeout;
    constructor(delay = 0, timeout = 3000) {
        this.delay = delay;
        this.timeout = timeout;
    }
    addJob(job) {
        return new Promise((resolve, reject) => {
            // Wrap the original job to handle its resolution or rejection
            const wrappedJob = () => job().then(resolve).catch(reject);
            // Push the wrapped job into the queue
            this.jobs.push(wrappedJob);
            // Start processing if not already doing so
            if (!this.isProcessing) {
                this.start();
            }
        });
    }
    start() {
        this.isProcessing = true;
        this.processJobs();
    }
    async processJobs() {
        while (this.jobs.length > 0) {
            const job = this.jobs.shift();
            try {
                await this.runJobWithTimeout(job);
            }
            catch (error) {
                // Log the error but continue processing
                console.error('Job error:', error);
                // Error is already propagated to the job's promise via reject
            }
            await this.delayJob(this.delay);
        }
        this.isProcessing = false;
    }
    async runJobWithTimeout(job) {
        return Promise.race([
            job(),
            new Promise((_, reject) => setTimeout(() => reject(new Error('Job timeout')), this.timeout))
        ]);
    }
    async delayJob(delay) {
        return new Promise(resolve => setTimeout(resolve, delay));
    }
}
//# sourceMappingURL=JobQueue.js.map